import httpClient from '@/lib/httpClient'
import { useQuery } from '@tanstack/react-query'

export interface Plan {
  plan_key: string
  name: string
  description: string | null
  amount: number | null
  currency: string
  interval: string
  interval_count: number
}

export default function useGetPlans({ enabled = true } = {}) {
  return useQuery<Plan[]>({
    queryKey: ['billing-plans'],
    queryFn: async () => {
      const response = await httpClient.get('billing/plans')
      return response.data
    },
    enabled,
    staleTime: 10 * 60 * 1000,
  })
}
